import React from "react";
import OurQualitiesSection from "../../Sections/OurQualitiesSection/Content";
const OurQualitiesPage = () => {
  return <OurQualitiesSection />;
};

export default OurQualitiesPage;
